// src/routes/SupplierRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Supplier Components
import ManageSuppliersPage from '../pages/supplier/ManageSuppliersPage';

const SupplierRoutes = () => {
  return (
    <Routes>
      {/* Supplier Management (List, Create, Edit in Modal) */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_all_suppliers">
            <ManageSuppliersPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default SupplierRoutes;